import { render, staticRenderFns } from "./FeaturesSection.vue?vue&type=template&id=2f37eccb&scoped=true&"
import script from "./FeaturesSection.vue?vue&type=script&lang=js&"
export * from "./FeaturesSection.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesSection.vue?vue&type=style&index=0&id=2f37eccb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f37eccb",
  null
  
)

export default component.exports